module.exports = __webpack_public_path__ + "img/ten.1da898b2.png";